module.exports = __webpack_public_path__ + "img/three_kids.ea331d0a.svg";